import Box from "../Box";
import LeaderboardListItem, {
	type LeaderboardListItemProps,
} from "../LeaderboardListItem";

interface Props {
	items: LeaderboardListItemProps[];
}

export const LeaderList = (props: Props) => {
	const { items } = props;
	return (
		<Box style={{ flex: 1 }} gap={8}>
			{items.map((item) => (
				<LeaderboardListItem
					key={item.rank}
					avatarType={
						item.avatarType === "initials" || !item.image?.endsWith(".svg")
							? "initials"
							: "identicon"
					}
					{...item}
				/>
			))}
		</Box>
	);
};
